import React from 'react';
import { motion } from 'framer-motion';
import { Music, Plus, ArrowRight, X } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';

const AddSongsRequiredModal = ({ isOpen, onClose, onNavigateToCatalogue }) => {
  if (!isOpen) return null;

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center p-4 z-[99999]"
      onClick={onClose}
    >
      <motion.div
        initial={{ scale: 0.95, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        exit={{ scale: 0.95, opacity: 0 }}
        className="bg-gray-900 border border-gray-700 rounded-xl max-w-md w-full mx-4"
        onClick={(e) => e.stopPropagation()}
      >
        <Card className="bg-transparent border-0">
          <CardHeader className="text-center pb-4">
            <div className="flex justify-end">
              <Button
                variant="ghost"
                size="sm"
                onClick={onClose}
                className="text-gray-400 hover:text-white"
              >
                <X className="w-4 h-4" />
              </Button>
            </div>
            <div className="flex justify-center mb-4">
              <div className="w-16 h-16 bg-gradient-to-r from-purple-500 to-pink-500 rounded-full flex items-center justify-center">
                <Music className="w-8 h-8 text-white" />
              </div>
            </div>
            <CardTitle className="text-xl text-white">🎵 Songs Required</CardTitle>
            <CardDescription className="text-gray-300">
              You need to add songs to your catalogue before going live!
            </CardDescription>
          </CardHeader>
          
          <CardContent className="space-y-6">
            <div className="text-center space-y-4">
              <p className="text-gray-300 text-sm leading-relaxed">
                Your audience needs to see what songs you can perform. Let's add some songs to your catalogue so you can start receiving requests!
              </p>
              
              <div className="bg-gray-800/50 border border-gray-700 rounded-lg p-4">
                <div className="flex items-center space-x-3 text-sm text-gray-300">
                  <div className="w-6 h-6 bg-blue-500 rounded-full flex items-center justify-center flex-shrink-0">
                    <span className="text-white text-xs font-bold">1</span>
                  </div>
                  <span>Add songs to your catalogue</span>
                </div>
                <div className="flex items-center space-x-3 text-sm text-gray-300 mt-2">
                  <div className="w-6 h-6 bg-green-500 rounded-full flex items-center justify-center flex-shrink-0">
                    <span className="text-white text-xs font-bold">2</span>
                  </div>
                  <span>Go live and start receiving requests!</span>
                </div>
              </div>
            </div>
            
            <div className="flex flex-col space-y-3">
              <Button
                onClick={() => {
                  onNavigateToCatalogue();
                  onClose();
                }}
                className="w-full bg-gradient-to-r from-purple-500 to-pink-500 hover:from-purple-600 hover:to-pink-600 text-white font-semibold py-3"
              >
                <Plus className="w-4 h-4 mr-2" />
                Add Songs to Catalogue
                <ArrowRight className="w-4 h-4 ml-2" />
              </Button>
              
              <Button
                variant="outline"
                onClick={onClose}
                className="w-full border-gray-600 text-gray-300 hover:bg-gray-800"
              >
                Maybe Later
              </Button>
            </div>
          </CardContent>
        </Card>
      </motion.div>
    </motion.div>
  );
};

export default AddSongsRequiredModal;

